<template>
  <v-app class="smartsurf">
    <SideBar v-if="showMenu" />
    <v-sheet class="overflow-hidden" style="position: relative;">
      <v-container fluid>
        <v-main v-bind:style="{ 'margin-left': marginLeft }"
          style="min-height: 1200px; padding-top: 0px; margin-bottom: 50px;">
          <router-view/>
        </v-main>
        <ModernSnackbar />
        <LoginDialog />

      </v-container>
    </v-sheet>
    <AppFooter />
  </v-app>
</template>

<script>

import ModernSnackbar from './components/General/ModernSnackbar'
import AppFooter from './components/General/AppFooter'
import SideBar from './components/General/SideBar'
import LoginDialog from './components/General/LoginDialog'


export default {
  inject: ['bus'],
  name: 'App',
  data () {
    return {
      marginLeft: '0px',
      showMenu: false,
    }
  },
  mounted () {
    document.title = "SmartSurf"
    if (this.validUser()) {
      this.showMenuAction()
    } else {
      this.hideMenu()
    }

    this.bus.on('loggedIn', () => {
      this.showMenuAction()
    })
    this.bus.on('logout', () => {
      this.hideMenu()
    })
  },
  methods: {
    hideMenu() {
      this.showMenu = false
      this.marginLeft = "0px"
    },
    showMenuAction() {
      if(this.validUser()) {
        this.showMenu = true
        this.marginLeft = "48px"
      }
    },
    validUser: function () {
      return this.$store.state.email !== ""
    }
  },
  components: {
    SideBar,
    ModernSnackbar,
    AppFooter,
    LoginDialog
  }
};
</script>

<style>
.smartsurf .s-chip {
  padding: 0 5px;
}
::-webkit-scrollbar
{
	width: 4px;
	height: 4px;
}
::-webkit-scrollbar-track
{
	background: rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-thumb
{
	background: rgba(0, 0, 0, 0.5);
}
* {
	scrollbar-width: thin;
	scrollbar-color: rgba(0, 0, 0, 0.5) rgba(0, 0, 0, 0.1);
}
.v-toolbar__extension {
  padding: 0px !important;
  height: unset !important; 
}
.v-breadcrumbs {
  padding: 6px 12px !important;
}
.nm-NoPaddingBot {
  padding-bottom: 0;
}
.nm-NoPaddingTopBot {
  padding-top: 0;
  padding-bottom: 0;
}
</style>